import {useLocation} from "react-router-dom";
import {useEffect} from "react";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        document.documentElement.scrollTop = 0; // For modern browsers
        document.body.scrollTop = 0; // For older browsers
    }, [pathname]);
    return null;
}
export default ScrollToTop;